import { render, staticRenderFns } from "./productMultiattribute.vue?vue&type=template&id=25131542&scoped=true&"
import script from "./productMultiattribute.vue?vue&type=script&lang=js&"
export * from "./productMultiattribute.vue?vue&type=script&lang=js&"
import style0 from "./productMultiattribute.vue?vue&type=style&index=0&id=25131542&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25131542",
  null
  
)

export default component.exports